import { getToken } from "../../services/HttpService";


export const postLogin = async (request) => {
    const endPoint = `${process.env.REACT_APP_API}/auth`; 
    const response = await getToken();

    const resp = await fetch(endPoint,{
        headers: {
            Authorization: `Bearer ${response.token}`,
            "Content-Type": "application/json"
        },
        method: 'POST',
        body: JSON.stringify(request),
        redirect: "follow"
    })

    return await resp.json();
}
